import React, { useState, useEffect } from 'react';

const ImageSlider = ({ images = [] }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [autoPlay, setAutoPlay] = useState(true);

    // Default images with real image paths
    const defaultImages = [
        {
            id: 1,
            image: '/images/s_01.jpg',  // Real image path
            gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',  // Fallback
            title: 'Modern Dental Care',
            description: 'State-of-the-art facility with latest technology'
        },
        {
            id: 2,
            image: '/images/s_02.jpg',
            gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
            title: 'Expert Dentists',
            description: '15+ years of experience in dental care'
        },
        {
            id: 3,
            image: '/images/s_03.jpg',
            gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
            title: 'Patient Comfort',
            description: 'Comfortable environment for pain-free treatment'
        },
        {
            id: 4,
            image: '/images/s_02.jpg',
            gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
            title: 'Advanced Equipment',
            description: 'Using latest dental technology and techniques'
        },
    ];

    const slidesData = images.length > 0 ? images : defaultImages;
    const totalSlides = slidesData.length;

    // Auto-play functionality
    useEffect(() => {
        if (!autoPlay) return;
        
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % totalSlides);
        }, 4000); // Change slide every 4 seconds

        return () => clearInterval(timer);
    }, [autoPlay, totalSlides]);

    const goToSlide = (index) => {
        setCurrentSlide(index);
        setAutoPlay(false);
    };

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % totalSlides);
        setAutoPlay(false);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
        setAutoPlay(false);
    };

    // Resume auto-play after user interaction
    useEffect(() => {
        const timer = setTimeout(() => {
            setAutoPlay(true);
        }, 5000);

        return () => clearTimeout(timer);
    }, [currentSlide]);

    const currentSlideData = slidesData[currentSlide];

    // Determine background - use image if available, otherwise gradient
    const getBackgroundStyle = () => {
        if (currentSlideData.image) {
            return {
                backgroundImage: `url(${currentSlideData.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            };
        }
        return {
            background: currentSlideData.gradient || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        };
    };

    return (
        <div className="image-slider">
            {/* Slide Container */}
            <div className="slider-container">
                <div 
                    className="slider-slide"
                    style={getBackgroundStyle()}
                >
                    {/* Dark overlay for better text visibility */}
                    <div className="slider-overlay"></div>

                    {/* Slide Content with Buttons */}
                    <div className="slide-content">
                        <h2 className="slide-title">{currentSlideData.title}</h2>
                        <p className="slide-description">{currentSlideData.description}</p>
                        
                        {/* Buttons in Middle of Slider */}
                        <div className="slider-buttons">
                            <button 
                                className="slider-btn slider-btn-primary"
                                onClick={() => {
                                    window.open('https://wa.me/+94714680485?text=Hi%20I%20would%20like%20to%20book%20an%20appointment', '_blank');
                                }}
                            >
                                📅 Make an Appointment
                            </button>
                            <button 
                                className="slider-btn slider-btn-secondary"
                                onClick={() => {
                                    window.location.href = 'tel:0714680485';
                                }}
                            >
                                📞 Call Now
                            </button>
                        </div>
                    </div>
                </div>

                {/* Previous Arrow */}
                <button 
                    className="slider-arrow slider-arrow-prev"
                    onClick={prevSlide}
                    aria-label="Previous slide"
                >
                    ❮
                </button>

                {/* Next Arrow */}
                <button 
                    className="slider-arrow slider-arrow-next"
                    onClick={nextSlide}
                    aria-label="Next slide"
                >
                    ❯
                </button>
            </div>

            {/* Dot Navigation */}
            <div className="slider-dots">
                {slidesData.map((_, index) => (
                    <button
                        key={index}
                        className={`slider-dot ${index === currentSlide ? 'active' : ''}`}
                        onClick={() => goToSlide(index)}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>

            {/* Slide Counter */}
            {/* <div className="slider-counter">
                {currentSlide + 1} / {totalSlides}
            </div> */}
        </div>
    );
};

export default ImageSlider;